import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        allVPM: [],
    },
    getters: {
        getVPM: state => {
            return state.allVPM
        },
    },
    mutations: {
        SET_VPM: (state, payload) => {
            state.allVPM = payload
        },
    },
    actions: {
        async FETCH_VPM(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "main/approval_vpm",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_VPM', response.data.data)
            })
                .catch(err => {
                    return err
                });
        },
    }
}